<script>
	var Q = require('q'),
		crudService = require('services/crudService'),
		productService = require('services/productService'),
		drupalPageService = require('services/drupalPageService'),
		urlUtilities = require('utilities/urlUtilities');

	function sortByCreationTime(a, b) {
		if (a.creationTimestamp < b.creationTimestamp) {
			return 1;
		} else if (a.creationTimestamp > b.creationTimestamp) {
			return -1;
		} else {
			return 0;
		}
	}

	module.exports = {
		components: {
			'info-icon': require('components/svg/info-icon.vue').default
		},
		data: function () {
			return {
				passages: null,
				aad: null,
				lessons: null,
				units: null,
				books: null,
				binderTooltip:
					'You can no longer save content to "My Binder." Passages and Article-A-Day sets currently saved in "My Binder" can be added to "My List." Lessons and Units cannot be added to "My List."'
			};
		},
		mounted() {
			var self = this;

			crudService.read('binder').then(function (entries) {
				var passages = [],
					aad = [],
					lessons = [],
					units = [],
					books = [],
					promises = [];

				entries.forEach(function (entry) {
					switch (entry.type) {
						case 'a':
							promises.push(
								productService
									.get(entry.productId)
									.then(function (product) {
										passages.push({
											href: urlUtilities.getProductURL(product),
											label: product.title
										});
									})
									.catch(function () {
										return true;
									})
							);

							break;
						case 'aad':
							promises.push(
								productService
									.get(entry.productId)
									.then(function (product) {
										aad.push({
											href: urlUtilities.getProductURL(product),
											label: product.title
										});
									})
									.catch(function () {
										return true;
									})
							);

							break;
						case 'l':
							promises.push(
								drupalPageService(entry.url)
									.then(function (drupalPage) {
										lessons.push({
											href: entry.url,
											label: $(drupalPage).find('#share-title').text()
										});
									})
									.catch(function () {
										return true;
									})
							);

							break;
						case 'u':
							promises.push(
								drupalPageService(entry.url)
									.then(function (drupalPage) {
										units.push({
											href: entry.url,
											label: $(drupalPage).find('#share-title').text()
										});
									})
									.catch(function () {
										return true;
									})
							);

							break;
						case 'b':
							promises.push(
								drupalPageService(entry.url)
									.then(function (drupalPage) {
										books.push({
											href: entry.url,
											label: $(drupalPage).find('#share-title').text()
										});
									})
									.catch(function () {
										return true;
									})
							);

							break;
					}
				});

				Q.all(promises).then(function () {
					if (passages.length) {
						passages.sort(sortByCreationTime);

						self.passages = passages;
					}

					if (aad.length) {
						aad.sort(sortByCreationTime);

						self.aad = aad;
					}

					if (lessons.length) {
						lessons.sort(sortByCreationTime);

						self.lessons = lessons;
					}

					if (units.length) {
						units.sort(sortByCreationTime);

						self.units = units;
					}

					if (books.length) {
						books.sort(sortByCreationTime);

						self.books = books;
					}
				});
			});
		}
	};
</script>
<template>
	<main
		class="main-content"
		role="main">
		<header class="iframe-header wrapper">
			<h1 class="main-header-title">
				My Binder
				<button
					class="button -link"
					v-tooltip="binderTooltip">
					<info-icon aria-label="My Binder"></info-icon>
				</button>
			</h1>
		</header>
		<div class="main-content wrapper">
			<section v-if="passages">
				<h2>My Passages</h2>
				<table>
					<tr
						v-for="row in passages"
						:key="row.label">
						<td>
							<a :href="row.href">{{ row.label }}</a>
						</td>
					</tr>
				</table>
			</section>
			<section v-if="lessons">
				<h2>My Lessons</h2>
				<table>
					<tr
						v-for="row in lessons"
						:key="row.label">
						<td>
							<a :href="row.href">{{ row.label }}</a>
						</td>
					</tr>
				</table>
			</section>
			<section v-if="units">
				<h2>My Units</h2>
				<table>
					<tr
						v-for="row in units"
						:key="row.label">
						<td>
							<a :href="row.href">{{ row.label }}</a>
						</td>
					</tr>
				</table>
			</section>
			<section v-if="aad">
				<h2>My Article-a-Days</h2>
				<table>
					<tr
						v-for="row in aad"
						:key="row.label">
						<td>
							<a :href="row.href">{{ row.label }}</a>
						</td>
					</tr>
				</table>
			</section>
			<section v-if="books">
				<h2>My Books</h2>
				<table>
					<tr
						v-for="row in books"
						:key="row.label">
						<td>
							<a :href="row.href">{{ row.label }}</a>
						</td>
					</tr>
				</table>
			</section>
		</div>
	</main>
</template>
<style lang="sass" scoped>
	@import 'config/colors';
	h2 {
		color: #005d71;
		font-size: 1rem;
	}

	h2,
	table,
	tbody {
		margin: 0;
	}

	table {
		margin-bottom: 1rem;
	}

	td {
		border: 1px solid #dfdfde;
		font-size: 0.75rem;
		padding: 0.25rem;
	}

	tr:nth-child(even) td {
		background-color: #f7f7f7;
	}

	div.main-content.wrapper {
		padding-top: 1rem;
	}

	.wrapper {
		max-width: 944px;
		h1.main-header-title {
			color: $c-blue;
			font-size: 1.5rem;
			margin: 0;
			display: inline-block
		}
	}
</style>
